import { initialState } from './reducer';

export interface ICommonStore {}

export function getInitialCommonStore(): ICommonStore {
  return { ...initialState };
}
